<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">No class selected.</b-alert>

          <div v-if="!error && !loading" class="div-section-body" style="padding: 0 2px 0 3px;">

            <b-row>
              <b-col cols="12">
                <h4 class="text-center">Launching Premium Classroom</h4>
                <div class="mt-4 mb-2" v-if="debug">
                    <b-button type="button" @click.stop.prevent="gotoClassSSO()" variant="danger" block size="lg" class="rounded">
                      Proceed to Classroom
                    </b-button>
                </div>
              </b-col>
            </b-row>

          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import constants from "@/config/constants"

export default {
  name: "ClassroomPremiumSSO",
  data() {
    return {
      debug: false,
      error: false,
      loading: true,
      msg: "Classroom Premium SSO",
      blurb: "Classroom blurb.",
      studentHash: this.$root.getToken(),
      lwClassId: '',
      lwUrl: '',
      showVideo: true,
      logging: false,
      enrolled: true
      }
  },
  props: {
    // route set to use props mapped to url parameters
    lw: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {  },
  components: {  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    gotoClassSSO(e) {
      this.gotoUrl(this.lwUrl)
    },
    gotoUrl(url) {
      // window.location.href = url
      window.location.replace = url
    }
  },
  created() {
    this.lwClassId = this.lw || this.$route.query.lw || ""
    if (this.lwClassId) {

      service.getClassSSO(this.lwClassId, this.studentHash)
      .then(
          ( data => {
              if (this.debug) console.log('gotoClassSSO', data)
              if (data.status) {
                  this.lwUrl = data.lwUrl
              }

          }).bind(this)
      )
      .finally ( e => {
        this.loading = false
        if (this.debug) console.log('gotoClassSSO lwUrl', this.lwUrl )
        if (this.debug && !window.confirm('Proceed to LearnWorlds?')) {
          return  // debugging - bail out
        }
        if (this.lwUrl) {
          window.location.href = this.lwUrl   // SSO Login to LW site
        }
        else {
          this.eror = true
        }
      })
      .catch(e => {
        this.error = true
        console.log(e)
      })
    } else {
      this.error = true
    }
  },
  mounted () { },
  beforeDestroy() {
    // console.log('beforeDestroy')
    // this.showVideo = false
    this.loading = true
    this.logging = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.thick-outline {
  border-width: 3px !important; /* Increase outline thickness */
}

.custom-opacity {
  opacity: .7;
}

.spnLimited {
  font-size: .8rem;
  font-weight: bold;
}

.custom-radius {
  border-radius: 12px !important;
}

.custom-padding {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.diagonal-strike {
  position: relative;
  display: inline-block;
  /* color: #000; */
}

.diagonal-strike::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: #FFF; /* or any color */
  transform: rotate(-20deg);
  transform-origin: center;
}

.card-clickable {
  cursor: pointer;
  transition: box-shadow 0.2s;
}
.card-clickable:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/components/ClassroomPremiumSSO.vue